import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'theme-ui';
import { alpha } from '@theme-ui/color';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import { CollapseIcon, ExpandIcon } from '../../images/icons';

import TextBlock from '../TextBlock';
import CTALink from '../CTALink';

const AccordionComponent = ({ pageBody: { accordionArr } }) => {
  return (
    <Box sx={accordionStyles.container}>
      <Accordion allowZeroExpanded>
        {accordionArr &&
          accordionArr.map((item) => {
            return (
              <AccordionItem key={item?._key}>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <AccordionItemState>
                      {({ expanded }) => (
                        <Box sx={accordionStyles.head(expanded)}>
                          {item?.title}
                          <Box sx={accordionStyles.head().icon}>{expanded ? <ExpandIcon /> : <CollapseIcon />}</Box>
                        </Box>
                      )}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <Box sx={accordionStyles.body}>
                    <TextBlock description={item?._rawText} styleBlock={accordionStyles.text} />
                    {item?.ctaLinks.map((link) => link?.link?.showLink && <CTALink key={item._key} linkData={link} />)}
                  </Box>
                </AccordionItemPanel>
              </AccordionItem>
            );
          })}
      </Accordion>
    </Box>
  );
};

AccordionComponent.defaultProps = {
  accordionArr: PropTypes.array,
};

export default AccordionComponent;

const accordionStyles = {
  container: {
    maxWidth: '880px',
    mx: 'auto',
    px: [3, null, 4],
    py: 6,
  },
  head: (expanded) => ({
    py: [3, null, 4],
    fontSize: ['32px', null, 6],
    fontFamily: 'heading',
    fontWeight: 'light',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    borderBottom: '1px solid',
    color: expanded ? 'text' : alpha('text', 0.35),
    icon: {
      flexShrink: 0,
    },
  }),
  body: {
    py: 3,
  },
  text: {
    pb: 0,
    pt: 2,
  },
};
